export default process.env.EXPO_ROUTER_IMPORT_MODE || ('sync' as 'sync' | 'lazy');
